/**
 * Insights page-context helpers
 * @module lib/insights/pageContext
 */

function isEnabledFlag(value) {
  if (value === true || value === 1) return true;
  if (typeof value !== 'string') return false;
  const normalized = value.trim().toLowerCase();
  return normalized === 'yes' || normalized === 'true' || normalized === '1';
}

function isSponsoredContent(ctx = {}) {
  const context = ctx || {};
  return isEnabledFlag(
    context._sponsored ?? context.sponsored ?? context.fwjson?.sponsored
  );
}

// Article topic tags for positive survey targeting. RebelMouse exposes them on
// fwjson.tags (array or comma-separated string); `~rmsc:`-prefixed entries are
// internal markers, not topics. Normalized to lowercase slugs to match the
// survey targeting tag conventions.
function readArticleTags(ctx = {}) {
  const context = ctx || {};
  const raw = context.fwjson?.tags ?? (typeof window !== 'undefined' ? window.fwjson?.tags : undefined);
  const values = Array.isArray(raw)
    ? raw
    : (typeof raw === 'string' ? raw.split(',') : []);
  const seen = new Set();
  const tags = [];
  values.forEach((value) => {
    const normalized = String(value || '').trim().toLowerCase();
    if (!normalized || normalized.indexOf('~rmsc:') === 0 || seen.has(normalized)) return;
    seen.add(normalized);
    tags.push(normalized);
  });
  return tags.slice(0, 30);
}

// RebelMouse lists every section of the post in post_sections, a JSON-array
// string such as "[551223148, 551223150, 551223143]". Body classes name only
// the primary section, which on MTL Blog is Editorial Sections for all posts.
function isStaticPage(ctx = {}) {
  const context = ctx || {};
  const sectionId = Number(context.staticPagesSectionId);
  if (!sectionId) return false;
  const raw = context.post_sections;
  const ids = Array.isArray(raw) ? raw : (String(raw ?? '').match(/\d+/g) || []);
  return ids.some((id) => Number(id) === sectionId);
}

// RebelMouse renders missing and unpublished URLs from its 404 layout:
// REBELMOUSE_BOOTSTRAP_DATA has resourceId "404" and path "/__rblms_404_v2".
// Google policy allows no ads on error pages ("Site behavior: Navigation").
function isNotFoundPage(ctx = {}) {
  const bootstrap = (ctx || {}).bootstrap;
  if (!bootstrap || typeof bootstrap !== 'object') return false;
  return String(bootstrap.resourceId ?? '') === '404'
    || String(bootstrap.path ?? '').indexOf('/__rblms_404') === 0;
}

function shouldSuppressInsightSurveyEmbed(ctx = {}) {
  const context = ctx || {};
  const pro = typeof context.pro === 'string' ? context.pro.trim().toLowerCase() : '';
  return (
    isSponsoredContent(context) ||
    isEnabledFlag(context._noads) ||
    isEnabledFlag(context._urlonly) ||
    pro === 'active'
  );
}

module.exports = {
  isEnabledFlag,
  isNotFoundPage,
  isSponsoredContent,
  isStaticPage,
  readArticleTags,
  shouldSuppressInsightSurveyEmbed
};
